<template>
<span v-if="eIf">
    <slot name="then"></slot>
</span>
<span v-else>
    <slot name="else"></slot>
</span>
</template>

<script>
export default {
    computed: {
        eIf () {
            return Boolean(this.$slots.if)
        },
    },
}
</script>
